<template>
  <div class="company-profile-widget">
    <div class="__head" :class="{__onscoll_header:isScoll}">
      <div
        class="personal_data"
        :style="{'background-image':$hasKey(user,'manager_info.profile.cover_photo') ? 'url('+$fullUrl('images/covers/'+user.manager_info.profile.cover_photo)+')' : false}"
      >
        <div class="person-card">
          <img
            v-if="user.company_info.company_logo"
            :src="$fullUrl('images/profiles/'+user.company_info.company_logo)"
          />
          <img v-else src="@/assets/icons/logo_avatar.svg" alt />
          <div class="info-text">
            <h2>{{user.company_info.company_name | validate }}</h2>
            <span>{{user.company_info.address | validate }}</span>
          </div>
        </div>
      </div>
      <div class="tabs-widget">
        <div class="tabs-links">
          <div
            class="tab"
            style="justify-content: flex-start;"
            :class="{active:tab_type == 'gen'}"
            @click="switchTab('gen')"
          >
            <span class="name">Public information</span>
            <span class="icon">
              <img
                v-if="tab_type == 'gen'"
                src="@/assets/icons/consultant-profile-icons/general-infos-active.svg"
              />
              <img v-else src="@/assets/icons/consultant-profile-icons/general-infos.svg" />
            </span>
          </div>
          <div class="tab" :class="{active:tab_type == 'cons'}" @click="switchTab('cons')">
            <span class="name">Consultants</span>
            <span class="icon">
              <img
                v-if="tab_type == 'cons'"
                src="@/assets/icons/consultant-profile-icons/consultants-active.svg"
              />
              <img v-else src="@/assets/icons/consultant-profile-icons/consultants.svg" />
            </span>
          </div>
          <div class="tab" :class="{active:tab_type == 'skills'}" @click="switchTab('skills')">
            <span class="name">Skills</span>
            <span class="icon">
              <img
                v-if="tab_type == 'skills'"
                src="@/assets/icons/consultant-profile-icons/skills-active.svg"
              />
              <img v-else src="@/assets/icons/consultant-profile-icons/skills.svg" />
            </span>
          </div>
          <div class="tab" :class="{active:tab_type == 'proj'}" @click="switchTab('proj')">
            <span class="name">Projects</span>
            <span class="icon">
              <img
                v-if="tab_type == 'proj'"
                src="@/assets/icons/consultant-profile-icons/projects-active.svg"
              />
              <img v-else src="@/assets/icons/consultant-profile-icons/projects.svg" />
            </span>
          </div>
          <div class="tab" :class="{active:tab_type == 'assign'}" @click="switchTab('assign')">
            <span class="name">Assignment</span>
            <span class="icon">
              <img
                v-if="tab_type == 'assign'"
                src="@/assets/icons/consultant-profile-icons/assignment-active.svg"
              />
              <img v-else src="@/assets/icons/consultant-profile-icons/assignment.svg" />
            </span>
          </div>
          <div class="tab" :class="{active:tab_type == 'pitch'}" @click="switchTab('pitch')">
            <span class="name">Pitches</span>
            <span class="icon">
              <img
                v-if="tab_type == 'pitch'"
                src="@/assets/icons/consultant-profile-icons/pitch-active.svg"
              />
              <img v-else src="@/assets/icons/consultant-profile-icons/pitch.svg" />
            </span>
          </div>
          <div
            class="tab"
            style="justify-content: flex-end;"
            :class="{active:tab_type == 'cvs'}"
            @click="switchTab('cvs')"
          >
            <span class="name">CVs</span>
            <span class="icon">
              <img
                v-if="tab_type == 'cvs'"
                src="@/assets/icons/consultant-profile-icons/cvs-active.svg"
              />
              <img v-else src="@/assets/icons/consultant-profile-icons/cvs.svg" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="__body" :class="{__onscoll_body:isScoll}" @scroll="onScoll">
      <div class="tab-body">
        <!-- General info -->
        <general-information v-if="tab_type == 'gen'" />
        <!-- End of genelar info -->

        <!-- Consultants -->
        <Consultants v-if="tab_type == 'cons'" />
        <!-- End of Consultants -->

        <!-- Skills -->
        <Skills v-if="tab_type == 'skills'" />
        <!-- End of Skills -->

        <!-- Projects -->
        <Projects v-if="tab_type == 'proj'" />
        <!-- End of Projects -->

        <!-- Assignments  -->
        <Assignments v-if="tab_type == 'assign'" />
        <!-- End of Assignments -->

        <!-- Pitches -->
        <Pitches v-if="tab_type == 'pitch'" />
        <!-- End Pitches -->

        <!-- Cvs -->
        <Cvs v-if="tab_type == 'cvs'" />
        <!-- End Cvs -->
      </div>
    </div>
  </div>
</template>
<script>
import generalInformation from "@/components/Company/generalInformation.vue";
import Consultants from "@/components/Company/Consultants.vue";
import Projects from "@/components/Company/Projects.vue";
import Assignments from "@/components/Company/Assignments.vue";
import Pitches from "@/components/Company/Pitches.vue";
import Skills from "@/components/Company/Skills.vue";
import Cvs from "@/components/Company/Cvs.vue";

import { mapGetters } from "vuex";
export default {
  name: "company-profile",
  components: {
    generalInformation,
    Consultants,
    Projects,
    Assignments,
    Pitches,
    Skills,
    Cvs,
  },
  props: {},
  data: () => {
    return {
      isScoll: false,
      tab_type: "gen",
      user: {
        company_info: {},
        manager_info: {},
        manager_profile: {},
      },
    };
  },
  beforeCreate() {},
  mounted() {
    let vm = this;
    vm.$store
      .dispatch("GET_ME_USER_COMPANY")
      .then((responce) => {
        vm.user = responce.data;
      })
      .catch((error) => {});
  },
  computed: {},
  methods: {
    onScoll({ target }) {
      // Modify header according to profile scoll
      let vm = this;
      vm.isScoll = true;
    },
    switchTab(type) {
      let vm = this;
      vm.tab_type = type;
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";
.company-profile-widget {
  background: #f7f7f7;
  min-height: 500px;
  width: 100%;
  padding-top: 52px;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  @media (min-width: 300px) and (max-width: 630px) {
    bottom: 45px;
  }
  .__head {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 210px;
    width: 100%;
    .personal_data {
      width: 100%;
      height: 160px;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;
      background-image: url($assets + "/images/backgrounds/wallpaper.svg");
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      .person-card {
        display: flex;
        align-items: center;
        flex-direction: column;

        img {
          width: 70px;
          height: 70px;
          border-radius: 100%;
          margin-bottom: 10px;
          object-fit: contain;
          transition: 400ms ease-in;
        }
        .info-text {
          display: flex;
          align-items: center;
          flex-direction: column;
          h2 {
            font-size: 20px;
            font-weight: bolder;
            margin-top: 0px;
            margin-bottom: 8px;
            color: #fff;
            text-transform: capitalize;
            transition: 400ms ease-in;
          }
          span {
            font-size: 15px;
            color: #fff;
            transition: 400ms ease-in;
          }
        }
      }
    }
    .tabs-widget {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      width: 100%;
      border-bottom: 1px solid #efefef;
      .tabs-links {
        width: 800px;
        display: grid;
        grid-template-columns: 14.2857142857% 22.285714% 14.2857142857% 14.2857142857% 19.285714% 10.285714% 5.285714%;
        @media (min-width: 300px) and (max-width: 630px) {
          grid-template-columns: 14.2% 14.2% 14.2% 14.2% 14.2% 14.2% 14.2%;
          width: 100%;
          padding: 0px 15px;
        }
        .tab {
          text-align: center;
          cursor: pointer;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          @media (min-width: 300px) and (max-width: 630px) {
            font-size: 11px;
          }
          .name {
            display: block;
            @media (min-width: 300px) and (max-width: 630px) {
              display: none;
            }
          }
          .icon {
            display: none;
            background: #dedede;
            height: 40px;
            width: 40px;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            @media (min-width: 300px) and (max-width: 630px) {
              display: flex;
            }
            img {
              width: 22.9px;
            }
          }
        }
        .tab.active {
          color: #04a5a5;
          font-weight: 800;
          .icon {
            background: #1890a9;
          }
        }
        .tab:hover {
          color: #04a5a5;
        }
      }
    }
  }
  .__onscoll_header {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 120px;
    width: 100%;
    transition: 200ms ease-in;
    .personal_data {
      width: 100%;
      height: 70px;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;
      .person-card {
        display: flex;
        align-items: center;
        flex-direction: row;

        img {
          width: 40px;
          height: 40px;
          border-radius: 100%;
          object-fit: contain;
          margin-right: 15px;
          transition: 400ms ease-in;
        }
        .info-text {
          display: flex;
          align-items: flex-start;
          flex-direction: column;
          h2 {
            font-size: 16px;
            font-weight: bolder;
            margin-top: -10px;
            margin-bottom: 0px;
            color: #fff;
            transition: 400ms ease-in;
          }
          span {
            font-size: 13px;
            color: #fff;
            transition: 400ms ease-in;
          }
        }
      }
    }
  }
  .__body {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    height: calc(100% - 210px);
    overflow-x: hidden;
    overflow-y: auto;
    padding-top: 15px;
    position: relative;
    @media (min-width: 300px) and (max-width: 630px) {
      padding-top: 0px;
    }
    .tab-body {
      width: 800px;
      @media (min-width: 300px) and (max-width: 630px) {
        width: 100%;
      }
    }
  }
  .__onscoll_body {
    height: calc(100% - 120px);
  }
}
.input-flex {
  display: flex;
}
</style>